import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex pb-x6" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-2 md:gap-x2"
}
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-x2" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 md:gap-x2" }
const _hoisted_5 = { class: "md:w-1/2 md:pr-x1" }

import PostalCodeSuggest from '@/shared/address/ui/PostalCodeSuggest.vue';
import { computed, ref, watch } from 'vue';
import { CustomerType } from '@/b2c/shared/address/ui/base-address-form.types';
import InputText from '@/shared/form/InputText.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAddressForm',
  props: {
    hideVatNumber: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any) {



const labels = useBlockLabels();


const { value: companyName, setValue: setCompanyName } = useField<string>('companyName');
const { value: vatNumber, setValue: setVatNumber } = useField<string>('vatNumber');
const customerTypeByFormData = computed<CustomerType>(() => companyName.value || vatNumber.value ? CustomerType.B2B : CustomerType.B2C);
const selectedCustomerType = ref<CustomerType>(CustomerType.B2C);
watch(customerTypeByFormData, (type) => {
    selectedCustomerType.value = type;
}, { immediate: true });
watch(selectedCustomerType, (type) => {
    if (type !== CustomerType.B2B) {
        setCompanyName('');
        setVatNumber('');
        selectedCustomerType.value = CustomerType.B2C;
    };
});

const { value: alternativePhone } = useField<string>('alternativePhoneNumber');
const altPhoneIsToggledByData = computed<boolean>(() => alternativePhone.value?.length > 0 ?? false);
const altPhoneIsToggled = ref<boolean>(altPhoneIsToggledByData.value);
watch(altPhoneIsToggledByData, (toggled) => {
    altPhoneIsToggled.value = toggled;
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  const _component_InputRadio = _resolveComponent("InputRadio")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_InputRadio, {
        modelValue: selectedCustomerType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCustomerType).value = $event)),
        value: _unref(CustomerType).B2C,
        name: "customerType",
        class: "mr-x6",
        label: _unref(labels).baseAddressCustomerTypeB2C
      }, null, 8, ["modelValue", "value", "label"]),
      _createVNode(_component_InputRadio, {
        modelValue: selectedCustomerType.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCustomerType).value = $event)),
        value: _unref(CustomerType).B2B,
        name: "customerType",
        label: _unref(labels).baseAddressCustomerTypeB2B
      }, null, 8, ["modelValue", "value", "label"])
    ]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "o-anim-fade-300"
    }, {
      default: _withCtx(() => [
        (selectedCustomerType.value === _unref(CustomerType).B2B)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(InputText, {
                name: "companyName",
                label: _unref(labels).baseAddressCompanyName,
                maxlength: "60"
              }, null, 8, ["label"]),
              (!__props.hideVatNumber)
                ? (_openBlock(), _createBlock(InputText, {
                    key: 0,
                    name: "vatNumber",
                    label: _unref(labels).baseAddressVatNumber
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(InputText, {
        name: "firstName",
        label: _unref(labels).baseAddressFirstName
      }, null, 8, ["label"]),
      _createVNode(InputText, {
        name: "lastName",
        label: _unref(labels).baseAddressLastName
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(InputText, {
        name: "street",
        label: _unref(labels).baseAddressStreet
      }, null, 8, ["label"]),
      _createVNode(InputText, {
        name: "extraInformation",
        label: _unref(labels).baseAddressStreet2
      }, null, 8, ["label"])
    ]),
    _createVNode(_component_InputCheckbox, {
      name: "hasLift",
      class: "pb-x6 -mt-20",
      "show-errors": false,
      label: _unref(labels).baseAddressLift
    }, null, 8, ["label"]),
    _createVNode(PostalCodeSuggest),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(InputText, {
        name: "country",
        readonly: "",
        "input-clear": false,
        label: _unref(labels).baseAddressCountry
      }, null, 8, ["label"])
    ])
  ]))
}
}

})